import { render, staticRenderFns } from "./waarom-lid-worden.vue?vue&type=template&id=08443325&"
import script from "./waarom-lid-worden.vue?vue&type=script&lang=js&"
export * from "./waarom-lid-worden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,EbookButton: require('/data/www/nvpa.org/nvpa/nuxt/components/ebook/Button.vue').default})
